import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../app-material.module';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { HttpService } from "../../services/http/http.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AddCodeDialog } from "../add-code-dialog/add-code-dialog.component";

@Component({
	selector: 'app-assemblea-decretazione',
	templateUrl: './assemblea-decretazione.component.html',
	styleUrls: ['./assemblea-decretazione.component.scss'],
	standalone: true,
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule]
})
export class AssembleaDecretazioneDialog implements OnInit {
	profiles: any[] = [];
	nomeDecreto : string = '';
	dataDecreto : Date = new Date();
	dataRiunione : Date = new Date();
	descrizione : string = '';
  idDocumentoDecreto : number;
  uploadedFile : any = {};
  disableRetryUploadButton : boolean = true;

	constructor(
		public dialogRef: MatDialogRef<AssembleaDecretazioneDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		public api: HttpService,
		private snackBar: MatSnackBar,
		private cdr: ChangeDetectorRef
	) {}

	get disableSubmit(){
		return !this.dataDecreto ||  !this.profiles?.filter(el => el.codiceProfilo).length;
	}
/*
  get uploadedFileName(){
    return this.uploadedFile?.name ?? 'Nessun documento caricato.'
  }*/

	ngOnInit(): void {
		this.api.getProfiliAssegnati(this.data.element.id).subscribe({
			next: (response: any) => {
				this.profiles = response.result;
				this.cdr.detectChanges();
			},
			error: (err: any) => {
				console.error('Errore durante il recupero dei profili:', err);
				this.snackBar.open('Errore durante il caricamento dei profili', 'close', { panelClass: 'errorSnack' });
			}
		});

		this.api.getAssemblea( this.data.element.id).subscribe({
			next: (response: any) => {
        const assemblea : any =  response.result;
				this.nomeDecreto =assemblea.nomeDecreto;
				this.descrizione = assemblea.descrizione;
        this.idDocumentoDecreto = assemblea.idDocumentoDecreto;
			}
		})
	}

	onClose(): void {
		this.dialogRef.close();
	}

	/*
  onFileUpload(event: any) {

    this.uploadedFile = event.target.files[0];

    if (!this.uploadedFile) { return; }

    this.uploadFile();
  }

  uploadFile(){
    this.api.uploadDocumentoDecreto(this.uploadedFile)
      .subscribe({
        next: (response: any) => {
          this.idDocumentoDecreto = response.result.valore;
        },
        error : (error : any) => {
          this.disableRetryUploadButton = false;
        }
      });
  }

  redoUpload(){
    this.idDocumentoDecreto = 0;
  }*/

	onSubmit(): void {
		const payload : {} = {
			id : this.data.element.id,
			dataDecreto : this.dataDecreto,
			nomeDecreto : this.nomeDecreto,
			dataRiunione : this.dataRiunione
     // idDocumentoDecreto : this.idDocumentoDecreto
		}

		this.api.chiudiAssemblea(payload)
			.subscribe({
				next: (response: any) => {

					if (response.operation != 3) {
					 // this.loadTable(this.savedEvent);
						this.snackBar.open('Assemblea chiusa correttamente', 'close', { panelClass: 'successSnack' });

						//  this.data['confirm'] = true;
						this.dialogRef.close();
					}
				}
		})
	}

	editProfileCode(profile: any, event : any) {
    const profileIndex : number = +event.target.dataset.index;
	const newProfile=this.profiles[profileIndex];
    this.api.precaricaCodiceProfilo(profile.descrizioneArea.id).subscribe({
			next: (response: any) => {
				const dialogRef = this.dialog.open(AddCodeDialog, {
					data: { newProfile, code: response.result.descrizione, idProposta : profile.idProposta}, width : '80%', height : '100%'
				});

				dialogRef.afterClosed().subscribe((result: any) => {
					if (result.confirm) {
            this.profiles[profileIndex].codiceProfilo = result.code;
					}
				});
			},
			error: (err: any) => {
				console.error('Errore durante il caricamento del codice:', err);
				this.snackBar.open('Errore durante il caricamento del codice', 'close', { panelClass: 'errorSnack' });
			}
		});
	}
}
